import { Stack, Tooltip } from "@mui/material";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import TimeSplitter from "src/utils/time-splitter";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import AvTimerIcon from "@mui/icons-material/AvTimer";
import React from "react";
import styled from "styled-components";
import Link from "@mui/material/Link";

const SubTitle = styled.h4`
    font-size: 12px;
    font-weight: 300;
`;

const EstimatedTotalsStack = ({ data, filterEstimatesBy }) => {
    if (data && data.tickets && !data.tickets.length)
        return (
            <SubTitle>
                No time{" "}
                <Link
                    href="https://support.atlassian.com/jira-software-cloud/docs/log-time-on-an-issue/"
                    target="_blank"
                >
                    spent/estimated
                </Link>{" "}
                set on your active tickets
            </SubTitle>
        );

    const filerResult = (type) => {
        if (filterEstimatesBy === "all") {
            if (type === "estimated") {
                return TimeSplitter(data.timeEstimatedAll, "tickets");
            }
            if (type === "spent") {
                return TimeSplitter(data.timeSpentAll, "tickets");
            }
        }
        if (filterEstimatesBy === "done") {
            if (type === "estimated") {
                return TimeSplitter(data.timeEstimatedDone, "tickets");
            }
            if (type === "spent") {
                return TimeSplitter(data.timeSpentDone, "tickets");
            }
        }
        if (filterEstimatesBy === "in-progress") {
            if (type === "estimated") {
                return TimeSplitter(data.timeEstimatedInProgress, "tickets");
            }
            if (type === "spent") {
                return TimeSplitter(data.timeSpentInProgress, "tickets");
            }
        }
        return null;
    };

    return (
        <Stack
            direction="row"
            spacing={1}
            style={{
                backgroundColor: "#303030",
                padding: "6px",
                borderRadius: "6px",
            }}
        >
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <HistoryToggleOffIcon fontSize="small" />
                <SubTitle style={{ fontWeight: "200" }}>Total time estimated</SubTitle>
                <SubTitle>
                    {(data && data.timeEstimatedAll && filerResult("estimated")) || "No time"}
                </SubTitle>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <QueryBuilderIcon fontSize="small" />
                <SubTitle style={{ fontWeight: "200" }}>Total time spent</SubTitle>
                <SubTitle>
                    {(data && data.timeSpentAll && filerResult("spent")) || "No time"}
                </SubTitle>
            </Stack>
            <Tooltip
                title={`Takes into account only tickets with both time spent and estimated set to greater than 0. There were ${
                    (data && data.underEstimatedCount) || 0
                } tickets fulfilling this requirement in this case`}
            >
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <AvTimerIcon fontSize="small" />

                    <SubTitle style={{ fontWeight: "200" }}>Under estimated by total</SubTitle>
                    <SubTitle>
                        {(data &&
                            data.underEstimatedSum &&
                            Math.sign(data.underEstimatedSum) *
                                TimeSplitter(Math.abs(data.underEstimatedSum), "tickets")) ||
                            "0s"}
                    </SubTitle>
                </Stack>
            </Tooltip>
        </Stack>
    );
};

export default EstimatedTotalsStack;
